import React from 'react';
import { TeamInLeague, TrainingFocus, Position } from '../../../domain/entities';
import { TRAINING_FOCUS_OPTIONS } from '../../../domain/constants';

interface TrainingPositionalPanelProps {
    team: TeamInLeague;
    onUpdatePositionalTrainingFocus: (position: Position, focus: TrainingFocus | null) => void;
}

const positions: Position[] = ['GK', 'DEF', 'MID', 'FWD'];

export const TrainingPositionalPanel: React.FC<TrainingPositionalPanelProps> = ({ team, onUpdatePositionalTrainingFocus }) => {
    return (
        <div className="panel">
            <div className="panel-header">Positional Focus</div>
            <div className="panel-content">
                <p>Set a training focus for a specific group of players. This will override the team-wide focus for those positions.</p>
                <div className="positional-focus-grid">
                    {positions.map(pos => (
                        <div key={pos} className="positional-focus-item">
                            <div className="form-group">
                                <label htmlFor={`${pos}-focus-select`}>{pos}</label>
                                <select id={`${pos}-focus-select`} value={team.positionalTrainingFocus[pos] || 'default'} onChange={e => onUpdatePositionalTrainingFocus(pos, e.target.value === 'default' ? null : e.target.value as TrainingFocus)}>
                                    <option value="default">Default to Team Focus ({team.trainingFocus})</option>
                                    {TRAINING_FOCUS_OPTIONS.map(opt => <option key={opt} value={opt}>{opt}</option>)}
                                </select>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};